<div class="panel-messagebox">
  <h1 class="panel-messagebox-title">{{headerInfo}}</h1>
  <p *ngIf="!showNummericInput" class="panel-messagebox-content">{{message}}</p>
  <p *ngIf="showNummericInput" class="panel-messagebox-content" [translate]="nummericHeader"
    [translateParams]="{'value': nummericValue}"></p>

  <!--slider-->
  <div class="panel-silder" *ngIf="showNummericInput">
    <div class="panel-slider-margin">
      <div class="vcenter full-width-slider">
        <app-slider #slider [min]="minValue" [max]="maxValue" [value]="nummericValue" [step]="stepSize"
          (input)="onSliderInput(slider.value)" (change)="onSliderChange(slider.value)"></app-slider>
      </div>
    </div>
  </div>

  <!--progress-->
  <div class="panel-progress" *ngIf="showProgress">
    <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
  </div>
  <div class="panel-progress" *ngIf="showIndeterminateProgress">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <!--buttons-->

  <div class="button-container no-select-clickable-items" *ngIf="buttons === MessageBoxCustomButton.OK">
    <button class="dialog-button dialog-button-last" mat-button (click)="onTrueClick()">
      <p>{{ 'MessageDialogComponent.OK' | translate }}</p>
    </button>
  </div>
  <div class="button-container no-select-clickable-items" *ngIf="buttons === MessageBoxCustomButton.Cancel">
    <button class="dialog-button dialog-button-last" mat-button (click)="onNoClick()">
      <p>{{ 'MessageDialogComponent.Cancel' | translate }}</p>
    </button>
  </div>
  <div class="button-container no-select-clickable-items" *ngIf="buttons === MessageBoxCustomButton.Yes">
    <button class="dialog-button dialog-button-last" mat-button (click)="onTrueClick()">
      <p>{{ 'MessageDialogComponent.Yes' | translate }}</p>
    </button>
  </div>
  <div class="button-container no-select-clickable-items" *ngIf="buttons === MessageBoxCustomButton.No">
    <button class="dialog-button dialog-button-last" mat-button (click)="onNoClick()">
      <p>{{ 'MessageDialogComponent.No' | translate }}</p>
    </button>
  </div>
  <div class="button-container no-select-clickable-items" *ngIf="buttons === MessageBoxCustomButton.OKCancel">
    <button class="dialog-button" mat-button (click)="onNoClick()">
      <p>{{ 'MessageDialogComponent.Cancel' | translate }}</p>
    </button>
    <button class="dialog-button dialog-button-last" mat-button (click)="onTrueClick()">
      <p>{{ 'MessageDialogComponent.OK' | translate }}</p>
    </button>
  </div>
  <div class="button-container no-select-clickable-items" *ngIf="buttons === MessageBoxCustomButton.YesNo">
    <button class="dialog-button" mat-button (click)="onNoClick()">
      <p>{{ 'MessageDialogComponent.No' | translate }}</p>
    </button>
    <button class="dialog-button dialog-button-last" mat-button (click)="onTrueClick()">
      <p>{{ 'MessageDialogComponent.Yes' | translate }}</p>
    </button>
  </div>
  <div class="button-container no-select-clickable-items" *ngIf="buttons === MessageBoxCustomButton.YesNoCancel">
    <button class="dialog-button" mat-button (click)="onNoClick()">
      <p>{{ 'MessageDialogComponent.No' | translate }}</p>
    </button>
    <button class="dialog-button" mat-button (click)="onNoClick()">
      <p>{{ 'MessageDialogComponent.Cancel' | translate }}</p>
    </button>
    <button class="dialog-button dialog-button-last" mat-button (click)="onTrueClick()">
      <p>{{ 'MessageDialogComponent.Yes' | translate }}</p>
    </button>
  </div>
  <div class="button-container-none no-select-clickable-items" *ngIf="buttons === MessageBoxCustomButton.None">

  </div>


</div>